// packages
import 'intersection-observer';
import yall from 'yall-js';
import Scroller from '@newswire/scroller';
import points from './map_points.json';
import route from './route.json';
import diazroute from './diazroute.json';

// local imports
import { AdLoader } from './ads/loader';
import { boot as bootNav } from './nav';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', () => yall());
bootNav();

mapboxgl.accessToken =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/latimes/cke1q769906gx19p7fswee3e4', // stylesheet location
  center: [-118.160928, 34.033503], // starting position [lng, lat]
  zoom: 15, // starting zoom
  interactive: false,
});

// route line
map.on('load', function () {
  map.addSource('route', route);
  map.addSource('diaz-route', diazroute);

  var brownColor = '#775F46';

  map.addLayer(
    {
      id: 'route',
      type: 'symbol',
      source: 'route',
      layout: {
        'symbol-placement': 'line',
        'text-field': '▶',
        'text-size': ['interpolate', ['linear'], ['zoom'], 12, 24, 22, 60],
        'symbol-spacing': ['interpolate', ['linear'], ['zoom'], 12, 65],
        'text-keep-upright': false,
        'text-allow-overlap': true,
        'visibility': 'none',
      },
      paint: {
        'text-color': brownColor,
        'text-halo-color': 'hsl(55, 11%, 96%)',
        'text-halo-width': 2,
      },
    },
    'waterway-label'
  );

  map.addLayer({
    id: 'route-line',
    type: 'line',
    source: 'route',
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
      'visibility': 'none',
    },
    paint: {
      'line-color': brownColor,
      'line-width': 8,
    },
  });

  map.addLayer({
    id: 'diaz-route',
    type: 'line',
    source: 'diaz-route',
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
      'visibility': 'none',
    },
    paint: {
      'line-color': brownColor,
      'line-width': 8,
    },
  });

  map.addLayer({
    id: 'diaz-route-arrows',
    type: 'symbol',
    source: 'diaz-route',
    layout: {
      'symbol-placement': 'line',
      'text-field': '▶',
      'text-size': ['interpolate', ['linear'], ['zoom'], 12, 24, 22, 60],
      'text-keep-upright': false,
      'text-ignore-placement': true,
      'visibility': 'none',
    },
    paint: {
      'text-color': brownColor,
      'text-halo-color': 'hsl(55, 11%, 96%)',
      'text-halo-width': 2,
    },
  });

  map.moveLayer('route-line', 'route');
  // map.moveLayer('diaz-route', 'diaz-route-arrows');

  map.scrollZoom.disable();

  var el;

  points.forEach(function (x) {
    el = document.createElement('div');
    el.className = 'map-point';
  });

  // for first route
  var el2 = document.createElement('div');
  el2.className = 'map-point';

  // for extra point in diaz route
  var el3 = document.createElement('div');
  el3.className = 'map-point';

  var mapMarker = new mapboxgl.Marker(el);
  var mapMarker2 = new mapboxgl.Marker(el2);
  var mapMarker3 = new mapboxgl.Marker(el3);

  // belvedere park popup
  var bpark = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });
  //laguna park popup
  var lpark = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });
  // green mill liquor
  var gmill = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });
  // tortillería
  var tortilleria = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });
  // fire station at Eastman Avenue and Verona Street
  var station = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });
  // diaz route 1st popup
  var diaz1 = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom-left',
  });
  // diaz route 2nd popup
  var diaz2 = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });
  // diaz route 3rd popup
  var diaz3 = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom-right',
  });
  // silver dollar
  var sdollar = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    offset: 1,
    anchor: 'bottom',
  });

  // var marker = new mapboxgl.Marker();
  // var marker2 = new mapboxgl.Marker();

  // sets up the scroller instance, pass in an array of all the scenes
  const scroller = new Scroller({
    scenes: document.querySelectorAll('.map-event'),
  });

  var eventList = document.querySelectorAll('.event-underline');

  function turnOffEventList() {
    for (var i = eventList.length - 1; i >= 0; i--) {
      eventList[i].classList.remove('event-underline-active');
    }
  }
  // Scroller has a tiny event emitter embedded in it!

  // the `enter` event is triggered every time a scene crosses the threshold
  scroller.on('scene:enter', (d) => {
    var point = points[d.index];

    turnOffEventList();

    bpark.remove();
    gmill.remove();
    tortilleria.remove();
    station.remove();
    diaz1.remove();
    diaz2.remove();
    diaz3.remove();
    sdollar.remove();

    //added these 'cause it wasn't going away
    map.setLayoutProperty('route-line', 'visibility', 'none');
    map.setLayoutProperty('route', 'visibility', 'none');
    map.setLayoutProperty('diaz-route', 'visibility', 'none');
    map.setLayoutProperty('diaz-route-arrows', 'visibility', 'none');

    d.element.querySelector('span').classList.add('event-underline-active');

    var viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;

    if (point.name === 'route') {
      map.setLayoutProperty('route-line', 'visibility', 'visible');
      map.setLayoutProperty('route', 'visibility', 'visible');

      // Geographic coordinates of the LineString
      var coordinates = route.data.geometry.coordinates;

      // Pass the first coordinates in the LineString to `lngLatBounds` &
      // wrap each coordinate pair in `extend` to include them in the bounds
      // result. A variation of this technique could be applied to zooming
      // to the bounds of multiple Points or Polygon geomteries - it just
      // requires wrapping all the coordinates with the extend method.
      var bounds = coordinates.reduce(function (bounds, coord) {
        return bounds.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

      if (viewportWidth < 769) {
        map.fitBounds(bounds, {
          padding: 60,
        });
      } else if (viewportWidth < 376) {
        map.fitBounds(bounds, {
          padding: 60,
        });
      } else {
        map.fitBounds(bounds, {
          padding: 80,
        });
      }

      mapMarker.setLngLat([-118.16092282533644, 34.03337456919408]);
      mapMarker2.setLngLat([-118.19057464599608, 34.02391167556398]);
      mapMarker.addTo(map);
      mapMarker2.addTo(map);

      gmill.remove();

      bpark.setLngLat([-118.16092282533644, 34.03337456919408]);
      bpark.setHTML('<p class="popup">Belvedere Park<p>');
      bpark.addTo(map);

      lpark.setLngLat([-118.19057464599608, 34.02391167556398]);
      lpark.setHTML('<p class="popup">Laguna Park</p>');
      lpark.addTo(map);
    } else if (point.name === 'Diaz') {
      map.setLayoutProperty('diaz-route', 'visibility', 'visible');
      map.setLayoutProperty('diaz-route-arrows', 'visibility', 'visible');

      // Geographic coordinates of the LineString
      var coordinates = diazroute.data.geometry.coordinates;

      // Pass the first coordinates in the LineString to `lngLatBounds` &
      // wrap each coordinate pair in `extend` to include them in the bounds
      // result. A variation of this technique could be applied to zooming
      // to the bounds of multiple Points or Polygon geomteries - it just
      // requires wrapping all the coordinates with the extend method.
      var bounds = coordinates.reduce(function (bounds, coord) {
        return bounds.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

      if (viewportWidth < 769) {
        map.fitBounds(bounds, {
          padding: 60,
        });
      } else if (viewportWidth < 376) {
        map.fitBounds(bounds, {
          padding: 35,
        });
      } else {
        map.fitBounds(bounds, {
          padding: 30,
        });
      }

      // first roadblock
      mapMarker.setLngLat([-118.19604635238646, 34.02559671247093]);
      // last point
      mapMarker2.setLngLat([-118.18621337413788, 34.02254672668261]);
      // second roadblock
      mapMarker3.setLngLat([-118.19313883781433, 34.024334049434735]);
      mapMarker.addTo(map);
      mapMarker2.addTo(map);
      mapMarker3.addTo(map);

      diaz1.setLngLat([-118.19604635238646, 34.02559671247093]);
      diaz1.setHTML('<p class="popup" id="route-1">First roadblock</p>');
      diaz1.addTo(map);

      diaz2.setLngLat([-118.19313883781433, 34.024334049434735]);
      diaz2.setHTML('<p class="popup" id="route-2">Second roadblock</p>');
      diaz2.addTo(map);

      diaz3.setLngLat([-118.18621337413788, 34.02254672668261]);
      diaz3.setHTML(
        '<p class="popup" id="route-3">Crashed into telephone pole</p>'
      );
      diaz3.addTo(map);
    } else {
      //remove popups
      bpark.remove();
      lpark.remove();

      // add marker to map
      var marker = new mapboxgl.Marker(el);

      mapMarker.setLngLat([point.longitude, point.latitude]);
      mapMarker.addTo(map);

      mapMarker2.remove();
      mapMarker3.remove();

      d.element.classList.add('active');
      map.flyTo({
        center: [point.longitude, point.latitude],
        zoom: point.zoom,
      });

      bpark.remove();
      gmill.remove();
      tortilleria.remove();
      station.remove();
      sdollar.remove();

      if (point.name === 'Belvedere Park') {
        bpark.setLngLat([-118.16092282533644, 34.03337456919408]);
        bpark.setHTML('<p class="popup">Belvedere Park<p>');
        bpark.addTo(map);
      } else if (point.name === 'Green Mill Liquor') {
        gmill.setLngLat([-118.191832, 34.0237]);
        gmill.setHTML('<p class="popup">Green Mill Liquor Store</p>');
        gmill.addTo(map);
      } else if (point.name === 'tortilleria') {
        tortilleria.setLngLat([-118.182169, 34.023829]);
        tortilleria.setHTML('<p class="popup">Velasquez Tortilleria</p>');
        tortilleria.addTo(map);
      } else if (point.name === 'verona st') {
        station.setLngLat([-118.186244, 34.022576]);
        station.setHTML('<p class="popup">L.A. County fire station</p>');
        station.addTo(map);
      } else if (point.name === 'Silver Dollar') {
        sdollar.setLngLat([-118.162437, 34.021705]);
        sdollar.setHTML('<p class="popup">Silver Dollar Bar & Cafe</p>');
        sdollar.addTo(map);
      }
    }
  });

  // the `exit` event is triggered every time a scene exits the threshold
  scroller.on('scene:exit', (d) => {
    d.element.classList.remove('active');
  });

  scroller.on('init', () => {
    // console.log('Everything is ready to go!');
  });

  // starts up the IntersectionObserver
  scroller.init();
});
